import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { LoginService } from '../services/login.service';
import { LoadingService } from '../services/loading.service';

export const clearStorageGuard: CanActivateFn = (route, state) => {
  const authService = inject(LoginService);
  const router = inject(Router);
  const loadingService = inject(LoadingService);

  loadingService.show();

  return authService.checkAccess().pipe(
    map(access => {
      loadingService.hide();
      if (access) {
        router.navigate(['/enrollment/layout']);
        return true;
      }
      localStorage.clear();
      return true;
    }),
    catchError(() => {
      loadingService.hide();
      localStorage.clear();
      return of(true);
    })
  );
};